export default __webpack_public_path__ + "static/media/estimate-step-2.0b4f3f7f.svg";